import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { List } from 'linqts';
import { Subscription } from 'rxjs/Subscription';

import { FormHelper } from '../../helpers/form-helper';
import { Meetup } from '../../models/meetup';
import { Member } from '../../models/member';
import { MeetupService } from '../../services/meetup.service';
import { MemberService } from '../../services/member.service';

@Component({
	selector: 'app-assign-members',
	templateUrl: './assign-members.component.html',
	styleUrls: ['./assign-members.component.scss']
})
export class AssignMembersComponent extends FormHelper implements OnInit, OnDestroy {
	private subscriptionManager: Subscription;
	private meetup: Meetup;
	public members: Array<Member> = [];
	public internal: Array<Member> = [];
	public external: Array<Member> = [];

	constructor(private dialogRef: MdDialogRef<AssignMembersComponent>,
		private formBuilder: FormBuilder,
		private meetupService: MeetupService,
		private memberService: MemberService) {
		super();
		this.subscriptionManager = new Subscription();

		this.buildForm();

		this.subscriptionManager.add(this.memberService.getMembers().subscribe(next => {
			let i: List<string> = new List<string>(this.meetup.internalMembers);
			let e: List<string> = new List<string>(this.meetup.externalMembers);

			next.forEach(element => {
				if (i.Where(m => m === element.$key).Count() > 0) {
					this.internal.push(element);
				} else {
					if (e.Where(m => m === element.$key).Count() > 0) {
						this.external.push(element);
					} else {
						this.members.push(element);
					}
				}
			});
		}));
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		this.subscriptionManager.unsubscribe();
	}

	public buildForm(): void {
		this.form = this.formBuilder.group({
			description: new FormControl('', Validators.required),
			number: new FormControl('', Validators.required),
			startsAt: new FormControl('', Validators.required),
			endsAt: new FormControl('', Validators.required),
			maxCouples: new FormControl('', Validators.required),
			coupleCost: new FormControl('', Validators.required)
		});
	}

	public updateForm(meetup: Meetup): void {
		this.meetup = meetup;
	}

	public async submitForm(): Promise<any> {
		this.meetup.internalMembers = [];
		this.meetup.externalMembers = [];

		this.internal.forEach(element => {
			this.meetup.internalMembers.push(element.$key);
		});

		this.external.forEach(element => {
			this.meetup.externalMembers.push(element.$key);
		});

		await this.meetupService.updateMeetup(this.meetup.$key, this.meetup);

		this.dialogRef.close();
	}
}



// WEBPACK FOOTER //
// C:/Source/Ecim/Ecim.Web/src/app/components/assign-members/assign-members.component.ts